import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackIdol, untrackIdol } from '@/shared/utils/idolOnlineTracker';

/**
 * 查詢某個偶像是否在線（見 docs/idol-online-plan.md §4）
 *
 * mount 時登記，由 idolOnlineTracker 合併查詢與輪詢；unmount 時取消登記。
 * 沒傳 idolId、或是自己目前使用中的偶像時不登記，一律回 false。
 *
 * @param {number} [idolId] 要查詢的偶像 id，必須是數字。不可傳 null 或字串：
 *   無效 id 會讓整批查詢回 SYSTEM_1001；字串與數字也會被當成不同的 id
 * @returns {boolean} 是否在線
 */
export function useIdolOnline(idolId) {
  const selfIdolId = useSelector((state) => state.user.idolId);
  const shouldTrack = idolId !== undefined && idolId !== selfIdolId;

  useEffect(() => {
    if (!shouldTrack) return;
    trackIdol(idolId);
    return () => untrackIdol(idolId);
  }, [shouldTrack, idolId]);

  return useSelector((state) => shouldTrack && state.online.byId[idolId] === true);
}
